module.exports = __webpack_public_path__ + "img/003.b3ee20a1.png";